module.exports = __webpack_public_path__ + "img/askmebet-support.fd7b4c68.png";